import apiFetch from '../../apiFetch'

export default function (idControlSangre) {
  return apiFetch({endPoint: `ControlSangre/getControlSangre?idControlSangre=${idControlSangre}`, method: 'GET', body: null})
}
